module.exports = __webpack_public_path__ + "static/assets/d43499e351e50f229977b20e78220428.png";